import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getCatalogoZonas } from '../../../../service/catalog/zonas';

export const useGetAll = (reloadGrid: number, filters: any) => {
  const [data, setData] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<number>(0);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getCatalogoZonas();
        if (res) {
          setData(res);
          setLoadingRequest(Math.random() * 40);
        }
      } catch (error) {
        history.push('/error/500');
      } finally {
        setLoadingRequest(0);
      }
    };

    if (reloadGrid) {
      fetchPost();
    }
  }, [reloadGrid, filters]);

  return { data, loadingRequest };
};
